/*
  BEELTRA V4.1 -- coverflow nativo (vanilla JS + CSS 3D transforms).
  Recreacion de COMPORTAMIENTO (centrado, vecinos visibles, perspectiva,
  drag/swipe, flechas, teclado, loop) de la referencia React suministrada
  por el owner. Sin React/Framer Motion/Tailwind.

  V1 autoplay (este bloque): motion automatica lenta y premium, que
  respeta hover/drag/foco/visibilidad de pestana/scroll/reduced-motion.
  Reutiliza el mismo goTo() -- no es un segundo sistema de animacion.
*/
(function () {
  function initCoverflow(root) {
    var viewport = root.querySelector('.beeltra-coverflow__viewport');
    var track = root.querySelector('.beeltra-coverflow__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.beeltra-coverflow__slide'));
    var prevBtn = root.querySelector('.beeltra-coverflow__arrow--prev');
    var nextBtn = root.querySelector('.beeltra-coverflow__arrow--next');
    if (!track || slides.length === 0) return;

    var count = slides.length;
    var activeIndex = Math.floor(count / 2);
    var spacing = 170;
    var dragOffset = 0;
    var isDragging = false;
    var dragStartX = 0;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function computeSpacing() {
      var w = viewport.getBoundingClientRect().width;
      // BEELTRA: clamp(148px, 22vw, 260px) como referencia conceptual del
      // ancho de card activa; el espaciado entre centros usa una fraccion
      // de eso para que las vecinas sigan siendo reconocibles.
      var cardWidth = Math.min(260, Math.max(148, w * 0.22));
      spacing = cardWidth * 0.72;
      root.style.setProperty('--beeltra-cf-card-w', cardWidth + 'px');
    }

    function normalize(i) {
      return ((i % count) + count) % count;
    }

    function shortestOffset(i) {
      var raw = i - activeIndex;
      if (raw > count / 2) raw -= count;
      if (raw < -count / 2) raw += count;
      return raw;
    }

    /* BEELTRA typography pass 2026-08-30: the fixed abs>3.2 cutoff below
       kept up to 7 slides simultaneously visible regardless of viewport
       width, reading as a wall of compressed thumbnails. Caps how many
       neighbors stay visible per breakpoint (~2*N+1 slides): 5 on large
       screens, 4 on desktop, 2-3 on tablet, 2 on mobile -- same
       perspective/scale/opacity mechanism, arrows, drag and autoplay,
       just a tighter visible range. */
    function maxVisibleAbs() {
      var w = viewport.getBoundingClientRect().width;
      if (w >= 1400) return 2.4; // ~5 visible
      if (w >= 990) return 1.9; // ~4 visible
      if (w >= 750) return 1.2; // ~3 visible
      return 0.7; // ~2 visible
    }

    function render() {
      var maxAbs = maxVisibleAbs();
      slides.forEach(function (slide, i) {
        var offset = shortestOffset(i) + (isDragging ? dragOffset / spacing : 0);
        var abs = Math.abs(offset);
        var translateX = offset * spacing;
        var rotateY = Math.max(-55, Math.min(55, offset * -32));
        var translateZ = -abs * 70;
        var scale = Math.max(0.72, 1 - abs * 0.16);
        var opacity = abs > maxAbs ? 0 : 1;
        var zIndex = 100 - Math.round(abs * 10);
        slide.style.transition = isDragging || prefersReducedMotion ? 'none' : 'transform 0.42s cubic-bezier(.22,.9,.36,1), opacity 0.42s ease';
        slide.style.transform =
          'translateX(' + translateX + 'px) translateZ(' + translateZ + 'px) rotateY(' + rotateY + 'deg) scale(' + scale + ')';
        slide.style.opacity = String(opacity);
        slide.style.zIndex = String(zIndex);
        slide.classList.toggle('is-active', Math.round(offset) === 0);
        var link = slide.querySelector('a');
        if (link) link.setAttribute('tabindex', Math.round(offset) === 0 ? '0' : '-1');
      });
    }

    function goTo(index) {
      activeIndex = normalize(index);
      render();
    }

    /* -----------------------------------------------------------------
       Autoplay V1 -- un solo temporizador (setTimeout encadenado, no
       setInterval), pausa por: hover, drag, foco de teclado, fuera de
       viewport, pestana oculta, prefers-reduced-motion. Reanuda con
       delay tras cada tipo de interaccion. Nunca pelea con el settle
       de goTo()/render(): solo reprograma el siguiente tick, nunca
       corre dos animaciones a la vez.
       ----------------------------------------------------------------- */
    var AUTOPLAY_DESKTOP_MS = 2500;
    var AUTOPLAY_MOBILE_MS = 3000;
    var RESUME_AFTER_INTERACTION_MS = 3000;
    var RESUME_AFTER_HOVER_MS = 1800;

    var isHovered = false;
    var hasFocus = false;
    var isVisible = false;
    var documentVisible = document.visibilityState === 'visible';
    var autoplayTimer = null;
    var resumeTimer = null;

    function isMobileViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function currentInterval() {
      return isMobileViewport() ? AUTOPLAY_MOBILE_MS : AUTOPLAY_DESKTOP_MS;
    }

    function canAutoplay() {
      return (
        !prefersReducedMotion &&
        !isHovered &&
        !isDragging &&
        !hasFocus &&
        isVisible &&
        documentVisible
      );
    }

    function clearAutoplayTimer() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function clearResumeTimer() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleAutoplay(delay) {
      clearAutoplayTimer();
      if (!canAutoplay()) return;
      autoplayTimer = setTimeout(function () {
        autoplayTimer = null;
        if (!canAutoplay()) return;
        goTo(activeIndex + 1);
        scheduleAutoplay(currentInterval());
      }, delay != null ? delay : currentInterval());
    }

    function pauseThenResume(delay) {
      clearAutoplayTimer();
      clearResumeTimer();
      resumeTimer = setTimeout(function () {
        resumeTimer = null;
        scheduleAutoplay(currentInterval());
      }, delay);
    }

    root.addEventListener('mouseenter', function () {
      isHovered = true;
      clearResumeTimer();
      clearAutoplayTimer();
    });
    root.addEventListener('mouseleave', function () {
      isHovered = false;
      pauseThenResume(RESUME_AFTER_HOVER_MS);
    });

    root.addEventListener('focusin', function () {
      hasFocus = true;
      clearResumeTimer();
      clearAutoplayTimer();
    });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      hasFocus = false;
      scheduleAutoplay(currentInterval());
    });

    function onVisibilityChange() {
      if (!root.isConnected) {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        return;
      }
      documentVisible = document.visibilityState === 'visible';
      if (documentVisible) {
        scheduleAutoplay(currentInterval());
      } else {
        clearAutoplayTimer();
        clearResumeTimer();
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isVisible = entry.isIntersecting;
            if (isVisible) {
              scheduleAutoplay(currentInterval());
            } else {
              clearAutoplayTimer();
              clearResumeTimer();
            }
          });
        },
        { threshold: 0.45 }
      );
      io.observe(root);
    } else {
      // Sin IntersectionObserver: se asume visible (navegador muy antiguo).
      isVisible = true;
    }
    /* ----------------------------------------------------------------- */

    slides.forEach(function (slide, i) {
      var link = slide.querySelector('a');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (i !== activeIndex) {
          e.preventDefault();
          goTo(i);
          pauseThenResume(RESUME_AFTER_INTERACTION_MS);
        }
        // si ya esta activa, el <a> real navega normalmente al PDP.
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
        pauseThenResume(RESUME_AFTER_INTERACTION_MS);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
        pauseThenResume(RESUME_AFTER_INTERACTION_MS);
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(activeIndex - 1);
        pauseThenResume(RESUME_AFTER_INTERACTION_MS);
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(activeIndex + 1);
        pauseThenResume(RESUME_AFTER_INTERACTION_MS);
      }
    });

    track.addEventListener('pointerdown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      dragOffset = 0;
      clearAutoplayTimer();
      clearResumeTimer();
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      dragOffset = e.clientX - dragStartX;
      render();
    });
    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      var moved = dragOffset;
      dragOffset = 0;
      if (moved > 40) {
        goTo(activeIndex - 1);
      } else if (moved < -40) {
        goTo(activeIndex + 1);
      } else {
        render();
      }
      pauseThenResume(RESUME_AFTER_INTERACTION_MS);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function () {
      if (isDragging) endDrag();
    });

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        computeSpacing();
        render();
      });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', function onResize() {
        if (!viewport.isConnected) {
          window.removeEventListener('resize', onResize);
          return;
        }
        computeSpacing();
        render();
      });
    }

    computeSpacing();
    render();
  }

  document.querySelectorAll('[data-beeltra-coverflow]').forEach(initCoverflow);
})();
